/* eslint-disable */
import * as Sentry from '@sentry/browser';
import { v4 as uuidv4 } from 'uuid';
import { getItem, setItem } from '~/es6/localstorage';
import { CONFIG } from "~/config";

export function getInstanceId() {
	let id = getItem("instance_id");

	if (!id) {
		id = uuidv4();
		setItem("instance_id", id);
	}

	return id;
}

export function initSentry() {
	Sentry.init({
		dsn: 'https://4c964e8270584957bf24c290aab2c9d5@sentry.pszn.cz/18',
		environment: window.location.hostname + (window.location.port ? ':' + window.location.port : ''),
		release: CONFIG.filesVersion,
		autoSessionTracking: true,
		tracesSampleRate: 0.6,
		ignoreErrors: [
			'NetworkError',
			'OfflineError',
			'ServiceUnavailableError',
			'ChunkLoadError',
			'RangeError',
			'TypeError: Failed to fetch',
			'TypeError: NetworkError when attempting to fetch resource.',
		],
		denyUrls: [
			// Facebook flakiness
			/graph\.facebook\.com/i,
			// Facebook blocked
			/connect\.facebook\.net\/en_US\/all\.js/i,
			// Woopra flakiness
			/eatdifferent\.com\.woopra-ns\.com/i,
			/static\.woopra\.com\/js\/woopra\.js/i,
			// Chrome extensions
			/extensions\//i,
			/^chrome:\/\//i,
			// Firefox
			/^moz\-extension:\/\//i,
			// Other plugins
			/127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
			/webappstoolbarba\.texthelp\.com\//i,
			/metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
		],
	});
	Sentry.configureScope(scope => scope.setUser({
		id: getInstanceId(),
		ip_address: "{{auto}}",
	}));
}
